var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.obj)?_c('list-expansion',{attrs:{"components":_vm.customComponents,"disabled":_vm.loading,"service-name":_vm.serviceName,"component-name":_vm.componentName},on:{"save-required":function($event){return _vm.$emit('save-required')}},model:{value:(_vm.obj),callback:function ($$v) {_vm.obj=$$v},expression:"obj"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }